var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-btn',{attrs:{"color":"teal","loading":_vm.loading,"block":_vm.block,"text":_vm.$t('common.export'),"icon":"mdi-export"},on:{"press":_setup.press}})
}
var staticRenderFns = []

export { render, staticRenderFns }